import React from 'react';

import { Flex, Text, RadioGroup } from '@lucidhq/lucidium';

import { usePermissions } from '~/components/Permissions/PermissionsProvider';
import { t } from '~/utils/i18n';

export enum MEDIA_TYPE {
  TRACKED_MEDIA = 'tracked_media',
  FORCED_EXPOSURE = 'forced_exposure'
}

interface MediaSelectFieldProps {
  value: MEDIA_TYPE;
  setValue: (value: MEDIA_TYPE) => void;
}

export const MediaSelectField = ({
  value,
  setValue
}: MediaSelectFieldProps) => {
  const { isAdmin } = usePermissions();

  const options = [
    { label: t('forms.labels.trackedMedia'), value: MEDIA_TYPE.TRACKED_MEDIA },
    ...(isAdmin
      ? [
          {
            label: t('forms.labels.forcedExposure'),
            value: MEDIA_TYPE.FORCED_EXPOSURE
          }
        ]
      : [])
  ];

  return (
    <Flex lss={{ flexDirection: 'column' }}>
      <Text
        lss={{ my: 'md', fontWeight: 'bold', fontSize: '1rem' }}
        as="strong"
      >
        {t(`campaignManager.campaignDetails.questions.media`)}
      </Text>

      <RadioGroup
        data-testid="media-select-field"
        isInline
        name="media_type"
        value={value}
        onChange={setValue}
        options={options}
      />
    </Flex>
  );
};
